import AuthFlowsContainer, {
  AuthFlowsContainerProps
} from "../../containers/AuthFlowsContainer";

export type SignUpCardFlowsContainerProps = {
  linkToSignIn: string;
};

export default function SignUpCardFlowsContainer(
  props: AuthFlowsContainerProps<SignUpCardFlowsContainerProps>
) {
  return <AuthFlowsContainer action="Sign up" {...props} />;
}
